import styled from 'styled-components'

export const StyledVolumesStepper = styled.div`
  height: 100px;
  margin: 30px 30px 0;
`
